export const openMedcart = ({ uuid }: { uuid: string }) => {
  const url = new URL('medcart://authenticate');
  url.searchParams.append('token', uuid);
  window.location.replace(url.toString());
};
